import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { BottomPanelService } from './bottom-panel.service';
@Component({
    selector: 'bottom-panel',
    templateUrl: './bottom-panel.html',
    styleUrls: ['./bottom-panel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class BottomPanelComponent implements OnChanges {
    private restrictionSubscriptions?: Subscription;
    @Input()
    bottomPanelRestricted?: string[];
    private visible = false;
    constructor(
        private elementRef: ElementRef,
        private bottomPanelService: BottomPanelService,
        private renderer: Renderer2
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['bottomPanelRestricted']) {
            this.restrictionSubscriptions?.unsubscribe();
            this.restrictionSubscriptions = new Subscription();
            if (this.bottomPanelRestricted) {
                this.restrictionSubscriptions.add(
                    ...this.bottomPanelRestricted.map(id => this.bottomPanelService.observe(id).subscribe(() => this.update()))
                );
            } else {
                this.update();
            }
        }
    }
    private update(): void {
        const shouldBeVisible = !this.bottomPanelRestricted?.find(id => this.bottomPanelService.getState(id).obs.value);
        if (this.visible !== shouldBeVisible) {
            this.visible = shouldBeVisible;
            switch (this.visible) {
                case true:
                    this.renderer.removeClass(this.elementRef.nativeElement, 'hidden');
                    break;
                default:
                    this.renderer.addClass(this.elementRef.nativeElement, 'hidden');
            }
        }
    }
}
